import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageShell from "./AdminPageShell";
import useFetch from "../../useFetch";
import { apiRequest } from "../../utils/api";
import Pagination from "../Pagination";

const AdminEmployers = () => {
  const perPage = 10;
  const [page, setPage] = useState(1);
  const [refreshKey, setRefreshKey] = useState(0);
  const [employers, setEmployers] = useState([]);
  const [meta, setMeta] = useState({});
  const [message, setMessage] = useState(false);
  const [actionError, setActionError] = useState(false);
  const apiUrl = process.env.REACT_APP_BASE_API_URL + `/admin/employers?per_page=${perPage}&page=${page}` + (refreshKey ? `&_=${refreshKey}` : "");
  const { response, isLoading, error } = useFetch(apiUrl);

  useEffect(() => {
    setEmployers(response?.employers?.data ?? []);
    setMeta(response?.employers?.meta ?? {});
  }, [response]);

  const refresh = () => setRefreshKey(Date.now());
  const referralText = (employer) => employer.referred_by?.epic_jobs_id
    ? `Referred by ${employer.referred_by.epic_jobs_id} (${employer.referred_by.name})`
    : "No referral";

  const updateStatus = (employer, accountStatus) => {
    if (!window.confirm(`${accountStatus === "blocked" ? "Block" : "Unblock"} this employer account?`)) return;

    setMessage(false);
    setActionError(false);
    const formData = new FormData();
    formData.append("account_status", accountStatus);

    apiRequest(`/admin/users/${employer.id}/status`, { method: "POST", body: formData })
      .then((data) => {
        setMessage(data.message);
        refresh();
      })
      .catch((error) => setActionError(error.message));
  };

  const removeEmployer = (employer) => {
    if (!window.confirm("Remove this employer account? This cannot be undone.")) return;

    setMessage(false);
    setActionError(false);
    apiRequest(`/admin/users/${employer.id}`, { method: "DELETE" })
      .then((data) => {
        setMessage(data.message);
        refresh();
      })
      .catch((error) => setActionError(error.message));
  };

  return (
    <AdminPageShell
      active="employers"
      title="Employers"
      text="Review employer accounts, jobs, applications, and access status."
    >
      <div className="ls-widget">
        <div className="widget-title">
          <h4>Employer Accounts</h4>
        </div>
        <div className="admin-crud-bar">
          <p>Super admin can block, unblock, or remove employer accounts.</p>
        </div>
        <div className="widget-content">
          {message && <div className="alert alert-success"><strong>{message}</strong></div>}
          {actionError && <div className="alert alert-danger"><strong>{actionError}</strong></div>}
          {error && <div className="alert alert-danger"><strong>{error}</strong></div>}
          {isLoading && <h5 className="text-center my-3">Loading Data</h5>}
          {!error && !isLoading && meta?.total > 0 && (
            <div className="admin-list-summary">Showing {employers.length} of {meta.total} employers</div>
          )}
          <div className="admin-table-list">
            {!error && !isLoading && employers.map((employer) => (
              <div className="admin-table-row" key={employer.id}>
                <div>
                  <strong>{employer.name}</strong>
                  <span>{employer.epic_jobs_id || "No Epic-Jobs ID"} - {employer.email} - {employer.plan_name} - {employer.jobs_count} jobs - {employer.applications_count} applicants</span>
                  <span>{referralText(employer)}</span>
                </div>
                <div className="admin-row-actions">
                  <span className={employer.account_status === "blocked" ? "danger" : ""}>{employer.account_status}</span>
                  <Link to={`/admin-employers/${employer.id}`} className="theme-btn btn-style-three">View</Link>
                  <button type="button" className="theme-btn btn-style-danger" onClick={() => removeEmployer(employer)}>Delete</button>
                  {employer.account_status === "blocked" ? (
                    <button type="button" className="theme-btn btn-style-success" onClick={() => updateStatus(employer, "active")}>Unblock</button>
                  ) : (
                    <button type="button" className="theme-btn btn-style-danger" onClick={() => updateStatus(employer, "blocked")}>Block</button>
                  )}
                </div>
              </div>
            ))}
            {!error && !isLoading && employers.length === 0 && <div className="admin-empty-state">No employers found.</div>}
          </div>
          {!error && !isLoading && <Pagination meta={meta} onPageChange={setPage} label="Employer pagination" />}
        </div>
      </div>
    </AdminPageShell>
  );
};

export default AdminEmployers;
